"use client";

import { HTMLAttributes, ReactNode } from "react";

interface MenuItemProps extends HTMLAttributes<HTMLDivElement> {
  icon?: ReactNode;
  shortcut?: string;
  danger?: boolean;
  disabled?: boolean;
  children?: ReactNode;
}

export function MenuItem({
  icon,
  shortcut,
  danger = false,
  disabled = false,
  children,
  className = "",
  ...props
}: MenuItemProps) {
  const baseStyles =
    "flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-colors select-none";

  const stateStyles = disabled
    ? "opacity-50 cursor-not-allowed"
    : danger
      ? "text-red-600 hover:bg-red-500/10 active:bg-red-500/20"
      : "text-[var(--color-text-primary)] hover:bg-[var(--color-surface-hover)] active:bg-[var(--color-surface-hover)]";

  return (
    <div className={`${baseStyles} ${stateStyles} ${className}`} {...props}>
      {icon && (
        <span className="flex-shrink-0 w-4 h-4 flex items-center justify-center">
          {icon}
        </span>
      )}
      <span className="flex-1 text-sm font-medium">{children}</span>
      {shortcut && (
        <span className="flex-shrink-0 text-xs font-mono text-[var(--color-text-muted)] bg-[var(--color-surface-hover)] px-1.5 py-0.5 rounded">
          {shortcut}
        </span>
      )}
    </div>
  );
}

export type { MenuItemProps };
